import AcxDialog from "components/UI/Dialog/AcxDialog";
import React, { useEffect, useState } from "react";
import { useStore } from "utils/useStore";
import SignalsPageStore from "../Store/SignalsPageStore";
import { useTheme } from "@mui/material";
import { Grid } from "@mui/material";
import AcxMainTextField from "components/UI/AcxMainTextField";
import AcxButton from "components/UI/AcxButton";
import { useNavigate } from "react-router";

export const CreateDashboardDialog = ({
    open,
    setOpen,
    disabled,
}: {
    open: boolean;
    setOpen: (open: boolean) => void;
    disabled?: boolean;
}) => {
    const signalsPageStore = useStore(SignalsPageStore);
    const navigate = useNavigate();

    const [isCreateAndPin, setIsCreateAndPin] = useState(false);
    const [createDashboardLoading, setCreateDashboardLoading] = useState(false);

    useEffect(() => {
        if (open === false) {
            setIsCreateAndPin(false);
            setNewDashboardTitle("");
        }
    }, [open, signalsPageStore]);
    const theme = useTheme();

    const [newDashboardTitle, setNewDashboardTitle] = useState("");

    return (
        <AcxDialog
            title={
                isCreateAndPin ? "Pin to New Dashboard" : "Create New Dashboard"
            }
            subTitle={
                isCreateAndPin
                    ? "Create a new dashboard and pin report"
                    : "Create a new dashboard"
            }
            dialogContentChildren={
                <Grid container style={{ width: "30vw" }} spacing={1}>
                    <Grid item xs={12}>
                        <AcxMainTextField
                            id="new-dashboard-title-input"
                            labelText="Dashboard Name"
                            value={newDashboardTitle}
                            onChange={(e) =>
                                setNewDashboardTitle(e.target.value)
                            }
                            required={!disabled}
                            isDisabled={disabled}
                            textContainerSx={{
                                backgroundColor: disabled
                                    ? theme.palette.lightgray.background
                                    : undefined,
                            }}
                        />
                    </Grid>
                </Grid>
            }
            isOpen={open}
            onClose={() => {
                setOpen(false);
                setIsCreateAndPin(false);
            }}
            disableEnforceFocus
            hideCancelButton
            maxWidth={false}
        >
            <AcxButton
                color="primary"
                onClick={async () => {
                    setCreateDashboardLoading(true);
                    const dashboard = await signalsPageStore.createDashboard({
                        title: newDashboardTitle,
                    });
                    setIsCreateAndPin(false);
                    setOpen(false);
                    setNewDashboardTitle("");
                    setCreateDashboardLoading(false);
                    if (!dashboard) return;
                    navigate("/app/signals/dashboard/" + dashboard.id);
                }}
                disabled={
                    !newDashboardTitle || disabled || createDashboardLoading
                }
                loading={createDashboardLoading}
            >
                {isCreateAndPin
                    ? "Create and Pin to Dashboard"
                    : "Create New Dashboard"}
            </AcxButton>
        </AcxDialog>
    );
};
